document.addEventListener('DOMContentLoaded', () => {
  // Selectores del header
  const headerSelectors = [
    '.header__inline-menu a',
    '.menu-drawer__menu a',
    '.mega-menu__link'
  ];
  // Selectores del footer (solo los que enviaste)
  const footerSelectors = [
    '.footer-block__details-content a'
  ];
  // Unimos todos los selectores
  const allSelectors = [...headerSelectors, ...footerSelectors].join(', ');
  // Seleccionamos todos los enlaces juntos
  const allLinks = document.querySelectorAll(allSelectors);
  allLinks.forEach(link => {
    const href = link.getAttribute('href');
    // 1️⃣ Eliminar "#" o "#!"
    if (href === '#' || href === '#!') {
      link.removeAttribute('href');
      link.style.cursor = 'default';
    }
    // 2️⃣ Abrir CDN/Calendly en nueva pestaña
    else if (
      href &&
      (href.startsWith('https://cdn') || href.startsWith('https://calendly'))
    ) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});